var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuestList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 19C1.25 19.4142 1.58579 19.75 2 19.75C2.41421 19.75 2.75 19.4142 2.75 19H1.25ZM13.25 19C13.25 19.4142 13.5858 19.75 14 19.75C14.4142 19.75 14.75 19.4142 14.75 19H13.25ZM2.75 19C2.75 17.2142 4.21421 15.75 6 15.75V14.25C3.38579 14.25 1.25 16.3858 1.25 19H2.75ZM6 15.75H10V14.25H6V15.75ZM10 15.75C11.7858 15.75 13.25 17.2142 13.25 19H14.75C14.75 16.3858 12.6142 14.25 10 14.25V15.75Z",
    fill: "#353B60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 6.00015C11.8999 7.40015 11.8999 9.60015 10.4999 10.9002C9.09993 12.2002 6.89993 12.3002 5.59993 10.9002C4.29993 9.50015 4.19993 7.40015 5.49993 6.00015C6.79993 4.60015 9.09993 4.70015 10.4999 6.00015",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.25C15.5858 13.25 15.25 13.5858 15.25 14C15.25 14.4142 15.5858 14.75 16 14.75V13.25ZM21.25 17C21.25 17.4142 21.5858 17.75 22 17.75C22.4142 17.75 22.75 17.4142 22.75 17H21.25ZM16 14.75H19V13.25H16V14.75ZM19 14.75C20.2858 14.75 21.25 15.7142 21.25 17H22.75C22.75 14.8858 21.1142 13.25 19 13.25V14.75Z",
    fill: "#353B60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2999 6.70039C20.2999 7.70039 20.2999 9.30039 19.2999 10.2004C18.2999 11.1004 16.6999 11.2004 15.7999 10.2004C14.8999 9.20039 14.7999 7.60039 15.7999 6.70039C16.6999 5.80039 18.2999 5.80039 19.2999 6.70039",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuestList);
export default __webpack_public_path__ + "static/media/guest-list.35d28a6c.svg";
export { ForwardRef as ReactComponent };